'use client';

import React from 'react';
import Link from 'next/link';
import { Search, ArrowUpDown, Filter, Clock, Plus } from 'lucide-react';

interface ServicesHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  onOpenNewService: () => void;
}

export function ServicesHeader({
  searchQuery,
  setSearchQuery,
  onOpenNewService
}: ServicesHeaderProps) {
  return (
    <div className="space-y-4">
      {/* Title */}
      <div>
        <h1 className="text-xl font-bold text-slate-900 tracking-tight">
          Editar servicios y categorías
        </h1>
      </div>

      {/* Action Bar */}
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
        {/* Search */}
        <div className="relative flex-1 max-w-xl">
          <Search className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
          <input
            type="text"
            placeholder="Buscar servicios..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200/90 rounded-xl text-xs text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-600 transition-all shadow-sm"
          />
        </div>

        {/* Buttons */}
        <div className="flex items-center gap-2 shrink-0">
          <button
            title="Reordenar servicios"
            className="p-2.5 bg-white border border-slate-200/90 hover:bg-slate-50 text-slate-600 rounded-xl transition-colors shadow-sm"
          >
            <ArrowUpDown className="w-4 h-4" />
          </button>

          <button
            title="Filtrar servicios"
            className="p-2.5 bg-white border border-slate-200/90 hover:bg-slate-50 text-slate-600 rounded-xl transition-colors shadow-sm"
          >
            <Filter className="w-4 h-4" />
          </button>

          <Link
            href="/dashboard/availability"
            className="flex items-center gap-1.5 px-3.5 py-2.5 bg-white border border-slate-200/90 hover:bg-slate-50 text-slate-700 text-xs font-semibold rounded-xl transition-colors shadow-sm"
          >
            <Clock className="w-3.5 h-3.5 text-slate-500" />
            <span>Horarios</span>
          </Link>

          <button
            onClick={onOpenNewService}
            className="flex items-center gap-1.5 px-4 py-2.5 bg-[#6255F5] hover:bg-[#5144E5] active:bg-[#4336D6] text-white text-xs font-semibold rounded-xl transition-all shadow-sm cursor-pointer"
          >
            <Plus className="w-4 h-4" />
            <span>+ Nuevo Servicio</span>
          </button>
        </div>
      </div>
    </div>
  );
}
